import { useEffect, useRef } from "react"

import { Form, TextArea, type GetRef } from "@/atoms"

import styles from "./StatusReason.module.scss"

import type { StatusReasonComponent } from "../DismissModal.types"

export const StatusReason: StatusReasonComponent = (props) => {
  const { t, status, name = "reason" } = props
  const reasonMaxLength = 1000
  const refTextArea = useRef<GetRef<typeof TextArea>>(null)
  const suggestionWrite = t(`triage.${status}_modal.suggest_write`)
  const reasonTitle = t(`triage.${status}_modal.reasonTitle`)

  useEffect(() => {
    refTextArea.current?.focus()
  }, [])

  return (
    <>
      <div className={styles.reasonTitle}>
        {reasonTitle}
        <span className={styles.recommended}>({t(`general.recommended`)})</span>
      </div>
      <Form.Item name={name}>
        <TextArea
          showCount
          autoSize={{ minRows: 3, maxRows: 6 }}
          ref={refTextArea}
          maxLength={reasonMaxLength}
          placeholder={suggestionWrite}
        />
      </Form.Item>
    </>
  )
}
